module.exports = __webpack_public_path__ + "static/media/maf-16.b24cf676.png";